export const SESSION_IO_VIEW_MODES = {
  STANDARD: 'standard',
  ADVANCED: 'advanced',
};

const asObject = value => {
  if (value == null) return {};
  return value;
};

const isPlainObject = value =>
  value != null && typeof value === 'object' && !Array.isArray(value);

export const hasIoEnvelope = component => Boolean(component?.io?.schemaVersion);

export const getDisplayStatus = component =>
  component?.io?.meta?.status || component?.status || '';

export const getDisplayError = component => {
  const ioError = component?.io?.diagnostics?.error;
  if (ioError == null || ioError === '') return component?.error || '';
  if (typeof ioError === 'string') return ioError;
  return JSON.stringify(ioError, null, 2);
};

export const getLegacyInputData = component => {
  if (!component) return {};

  const nested = component?.data?.data;
  const top = component?.data;
  const status = component?.status;

  if (status === 'SUCCESS' || status === 'SUCCESS_END') {
    const input = nested?.['.inputData'] ?? top?.['.inputData'];
    if (input == null) return {};
    return typeof input === 'string' ? input : { Input: input };
  }

  return asObject(nested || top || {});
};

export const getLegacyOutputData = component => {
  if (!component) return {};

  const payload = component?.data?.data ?? component?.data ?? {};
  if (!isPlainObject(payload)) return payload;

  const clone = { ...payload };
  delete clone['.inputData'];
  return clone;
};

export const getStandardInputData = component => {
  if (hasIoEnvelope(component)) {
    const ioInput = component?.io?.input?.resolved;
    if (ioInput != null) return ioInput;
  }
  return getLegacyInputData(component);
};

export const getStandardOutputData = component => {
  if (hasIoEnvelope(component)) {
    const ioOutput = component?.io?.output?.resolved;
    if (ioOutput != null) return ioOutput;
  }
  return getLegacyOutputData(component);
};

export const getInputBindingsData = component =>
  asObject(component?.io?.input?.bindings || []);

export const getExportMapData = component =>
  asObject(component?.io?.output?.exports || []);

export const getDiagnosticsData = component =>
  asObject(component?.io?.diagnostics || {});

export const getRawIoData = component =>
  asObject(component?.io || {});

export const shouldShowStandardExports = component => {
  if (!hasIoEnvelope(component)) return false;

  const exports = Array.isArray(component?.io?.output?.exports)
    ? component.io.output.exports.filter(x => x?.key)
    : [];
  if (!exports.length) return false;

  const output = component?.io?.output?.resolved;
  if (!isPlainObject(output)) return true;

  const outputKeys = new Set(Object.keys(output));
  if (!outputKeys.size) return true;

  return exports.some(exp => !outputKeys.has(exp.key));
};

export const getStandardExportSummaryData = component => {
  const exports = Array.isArray(component?.io?.output?.exports)
    ? component.io.output.exports.filter(x => x?.key)
    : [];

  const summary = {};
  for (const exp of exports) {
    summary[exp.key] = {
      type: exp.type || 'text',
      path: exp.path || exp.key,
      redacted: Boolean(exp.isRedacted),
    };
  }

  return summary;
};
